import { Button, Modal } from '@mantine/core';
import React, { useState } from 'react';
import { FaRegPaperPlane } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import useFirebaseFunction from "../../utils/useFirebaseFunction";

const ModalCreateBoardComponent = ({opened, setOpened}) => {
    const [create_board, isLoading] = useFirebaseFunction("create_board","europe-west1");
    const [value, setValue] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        if(e.target.value.match("^[a-z0-9]*$") != null){
            setValue(e.target.value);
        }
    }


    const save = () => {
        setError('');

        if(value.length === 0) {
            return setError('Subdomain-ul este invalid');
        }

        create_board({subdomain: value}).then((data) => {
            if (data) {
                //window.location.href = `/${value}`;
                navigate(`/${value}`);
            } else {
                return setError("Subdomaniul nu este disponbil")
            }
        })
    }

    return (
        <Modal
            centered={true}
            opened={true}
            withCloseButton={false}
            onClose={() => setOpened(false)}
            className="mx-2"
        >
            <div className="bg-white flex flex-col justify-center items-center">
                <div className="flex flex-col justify-center items-center">
                    <div className="rounded-full p-4 flex justify-center items-center border-4 border-mainBlue">
                        <FaRegPaperPlane size={45} color="#01A5F1" className="mr-1" />
                    </div>
                    <h1 className="fontButton text-mainBlue text-[20px] mb-6">Setări URL</h1>
                    <p className="text-mainBlue text-[16px] fontButton">Adaugă un nume pentru pagina ta</p>
                </div>
                <div className={`border border-gray-300 rounded-md py-2 px-2 text-center flex items-center justify-center mt-10 ${error.length > 0 ? 'mb-2' : 'mb-8'}`}>
                    <p className="text-center flex-1">picboard.ro/</p>
                    <input
                        type="text"
                        className="outline-none"
                        value={value}
                        onChange={handleChange}
                    />
                </div>
                {error.length > 0 && <p className="text-red-500 text-sm mb-6">{error}</p>}

                <div className="flex justify-center items-center gap-x-6">
                    <Button color="gray" onClick={() => setOpened(false)} >Anulează</Button>
                    <Button loading={isLoading} onClick={() => save()}> Salvează</Button>
                </div>
            </div>
        </Modal>
    )
}

export default ModalCreateBoardComponent